<template>

  <div class="kontoverbindung">

    <div class="primary--text semanticsection-title2">Kontoverbindung</div>

    <div>

      <iban-field v-model="iban"
                    v-validate="'required|iban-validator'"
                    :error-messages="errors.collect('iban')"
                    data-vv-as="IBAN"
                    name="iban"
                    label="IBAN"
                    placeholder="DE00 0000 0000 0000 0000 00"
                    class="required"
                    autocorrect="off"
                    spellcheck="false" />

      <template v-if="$helpers.isIbanAusland(iban)">

        <v-text-field v-model="bic"
                      v-validate="'required|bic-validator'"
                      v-dmb-trim
                      :error-messages="errors.collect('bic')"
                      data-vv-as="BIC"
                      name="bic"
                      label="BIC"
                      hint="Bitte geben Sie für ausländische Konten die BIC ein."
                      class="required" />

      </template>

      <v-row no-gutters>

        <v-col cols="12"
               sm="6">
          <div class="dmb-form-text pt-1 pr-2">Ist das versicherte Unternehmen Beitragszahler und Kontoinhaber?*</div>
        </v-col>

        <v-col cols="12"
               sm="6">
          <v-radio-group v-model="vnIsKontoinhaber"
                         name="inhabertyp"
                         hide-details
                         row>

            <v-radio label="Ja"
                     :value="true"
                     color="primary" />

            <v-radio label="Nein"
                     :value="false"
                     color="primary" />

          </v-radio-group>
        </v-col>

      </v-row>
    </div>

    <template v-if="!vnIsKontoinhaber && kontoinhaber">

      <div class="primary--text semanticsection-title2">Kontoinhaber</div>

      <gewerbe-person :state-path="personPath(kontoinhaber.key)"
                      :unused="['kontakt', 'staat', 'beruf']"
                      class="mb-n4" >
      </gewerbe-person>

    </template>

  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import {mapGetters} from "vuex";
import GewerbePerson from './GewerbePerson';
import IbanField from "@/components/IbanField";

export default {
  components: { GewerbePerson, IbanField },
  mixins: [ValidationMixin, twowayBinding],
  computed: {
    ...mapTwoWay([
      'iban',
      'bic',
      'ref'
    ], {}, 'gewerbe.konto'),
    ...mapGetters([
      'kontoinhaber',
      'versicherungsnehmer',
      'personPath'
    ]),
    vnIsKontoinhaber: {
      get() {
        return this.ref === 'vn1';
      },
      set(value) {
        if (value) {
          this.ref = 'vn1';
        } else {
          if (!this.kontoinhaber) this.$store.commit('gewerbeAddKontoinhaber');
          this.ref = this.kontoinhaber.key;
        }
      }
    }
  }
};
</script>


